import { Controller } from "@hotwired/stimulus"

// inline '이미 완료된 개선 기록' 폼 토글 — transition #0 ((없음) → completed 직행).
// inline-edit / inline-complete / inline-compare 와 동일 패턴.
export default class extends Controller {
  static targets = ["form"]

  toggle(event) {
    if (event) event.preventDefault()
    this.formTarget.classList.toggle("hidden")
    if (!this.formTarget.classList.contains("hidden")) {
      this.formTarget.scrollIntoView({ behavior: "smooth", block: "start" })
      const first = this.formTarget.querySelector("input, select, textarea")
      if (first) first.focus()
    }
  }

  hide() {
    this.formTarget.classList.add("hidden")
  }
}
